import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import Avatar from "@mui/material/Avatar";


const CalenderIcon = (props:any) => {
  return (
      <Avatar sx={{ bgcolor: "#39A2DB", borderRadius: "15px", cursor: "pointer", marginRight: "10px" }} onClick={props.handleClickOpen}>
          <CalendarTodayIcon sx={{ color: "white" }} />
      </Avatar>
  )
}

export default CalenderIcon;

